var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrayPercent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Percent"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M15.8307 4.1665L4.16406 15.8332M7.4974 5.83317C7.4974 6.75365 6.7512 7.49984 5.83073 7.49984C4.91025 7.49984 4.16406 6.75365 4.16406 5.83317C4.16406 4.9127 4.91025 4.1665 5.83073 4.1665C6.7512 4.1665 7.4974 4.9127 7.4974 5.83317ZM15.8307 14.1665C15.8307 15.087 15.0845 15.8332 14.1641 15.8332C13.2436 15.8332 12.4974 15.087 12.4974 14.1665C12.4974 13.246 13.2436 12.4998 14.1641 12.4998C15.0845 12.4998 15.8307 13.246 15.8307 14.1665Z",
    stroke: "#B1B1B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayPercent);
export default __webpack_public_path__ + "static/media/gray-percent.9018f4c6ccc9e6e940ea1ac1a012eeee.svg";
export { ForwardRef as ReactComponent };